import React, { useEffect, useState, useRef } from "react"
import axios from 'axios'
import { AutoTextSize } from 'auto-text-size';

export default function Main() {

    const [isPaid, setIsPaid] = useState(0)
    const [isPaid2, setIsPaid2] = useState(0)
    const [isPaid3, setIsPaid3] = useState(0)

    const is_paid =() => {
        axios.get(`${process.env.REACT_APP_BACKEND}/is_paid`).then((response) => {
            //setPost(response.data);
            //alert(JSON.stringify(response.data))
                //console.log(response.data.paid)
                if(response.data.paid === 1){
                    setIsPaid(response.data.paid)
                }else if (response.data.paid === 0){
                    setIsPaid(response.data.paid)
                    is_completed_twenty()
                }
        });
     }

     const is_paid2 =() => {
        axios.get(`${process.env.REACT_APP_BACKEND}/is_paid?hsk=${'_hsk2'}`).then((response) => {
            //setPost(response.data);
            //alert(JSON.stringify(response.data))
                //console.log(response.data.paid)
                if(response.data.paid === 1){
                    setIsPaid2(response.data.paid)
                }else if (response.data.paid === 0){
                    setIsPaid2(response.data.paid)
                    is_completed_twenty2()
                }
        });
     }


     const is_paid3 =() => {
        axios.get(`${process.env.REACT_APP_BACKEND}/is_paid?hsk=${'_hsk3'}`).then((response) => {
            //setPost(response.data);
            //alert(JSON.stringify(response.data))
                //console.log(response.data.paid)
                if(response.data.paid === 1){
                    setIsPaid3(response.data.paid)
                }else if (response.data.paid === 0){
                    setIsPaid3(response.data.paid)
                    is_completed_twenty3()
                }
        });
     }


     
    useEffect(() => {
        is_paid()
        const fetchData = async () => {
            await countScore();
        };

        fetchData();

        const fetchData2 = async () => {
            await countScore2();
        };

        fetchData2();

        const fetchData3 = async () => {
            await countScore3();
        };

        fetchData3();
    }, [])

    const [completedTwenty, setCompletedTwenty] = useState(0)
    const [percentage, setPercentage] = useState(0)

    const [completedTwenty2, setCompletedTwenty2] = useState(0)
    const [percentage2, setPercentage2] = useState(0)

    const [completedTwenty3, setCompletedTwenty3] = useState(0)
    const [percentage3, setPercentage3] = useState(0)

    const is_completed_twenty =() => {
        axios.get(`${process.env.REACT_APP_BACKEND}/is_completed_twenty`).then((response) => {
            //setPost(response.data);
            //alert(JSON.stringify(response.data))
            if (response.data.completed){
                setCompletedTwenty(response.data.completed)
            } 
        });
     }

     const is_completed_twenty2 =() => {
        axios.get(`${process.env.REACT_APP_BACKEND}/is_completed_twenty?hsk=${'_hsk2'}`).then((response) => {
            //setPost(response.data);
            //alert(JSON.stringify(response.data))
            if (response.data.completed){
                setCompletedTwenty(response.data.completed)
            } 
        });
     }

     const is_completed_twenty3 =() => {
        axios.get(`${process.env.REACT_APP_BACKEND}/is_completed_twenty?hsk=${'_hsk3'}`).then((response) => {
            //setPost(response.data);
            //alert(JSON.stringify(response.data))
            if (response.data.completed){
                setCompletedTwenty(response.data.completed)
            } 
        });
     }

     const countScore = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND}/countScore`);
            if (response.data.score !== undefined) {
                setPercentage(response.data.score);
                //console.log('the result is', response.data.score);
            }
        } catch (error) {
            console.error('Error fetching the score:', error);
        }
    };

    const countScore2 = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND}/countScore?hsk=${'_hsk2'}`);
            if (response.data.score !== undefined) {
                setPercentage2(response.data.score);
                //console.log('the result is', response.data.score);
            }
        } catch (error) {
            console.error('Error fetching the score:', error);
        }
    };

    const countScore3 = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND}/countScore?hsk=${'_hsk3'}`);
            if (response.data.score !== undefined) {
                setPercentage3(response.data.score);
                //console.log('the result is', response.data.score);
            }
        } catch (error) {
            console.error('Error fetching the score:', error);
        }
    };
 
    
    const THRESHOLD_A = 552;
    const BASE_A = 470;
    const OFFSET_A = 90;

    // Div B settings
    const THRESHOLD_B = 552;
    const BASE_B = 100;
    const OFFSET_B = 0;

    const [divHeightA, setDivHeightA] = useState(null);
    const [divHeightB, setDivHeightB] = useState(null);

        const computeA = () => {
        const vh = Math.floor(window.innerHeight);

        // Special case: very small screen (start scaling when < 550)
        if (vh < THRESHOLD_A - 2) {
            const MIN_VH = 300; // minimum expected screen height
            const MAX_VH = THRESHOLD_A - 2; // 550

            const clampedVh = Math.max(vh, MIN_VH);
            const scale = (clampedVh - MIN_VH) / (MAX_VH - MIN_VH);

            const MIN_HEIGHT = 200; // min allowed div height
            const MAX_HEIGHT = BASE_A; // full size at 550px+

            return Math.floor(MIN_HEIGHT + (MAX_HEIGHT - MIN_HEIGHT) * scale);
        }

        // Normal logic (unchanged)
        if (vh <= THRESHOLD_A) return null;

        const cappedVh = Math.min(vh, 1153);
        const delta = cappedVh - THRESHOLD_A;

        const OFFSET_FADE_START = THRESHOLD_A;
        const OFFSET_FADE_END = 660;
        const offsetRange = OFFSET_FADE_END - OFFSET_FADE_START;

        let fadeOffset;
        if (vh < OFFSET_FADE_END) {
            fadeOffset = OFFSET_A * ((vh - OFFSET_FADE_START) / offsetRange);
        } else {
            fadeOffset = OFFSET_A;
        }

        const raw = BASE_A + delta;
        const adjusted = raw - fadeOffset;

        return Math.max(0, adjusted);
        };

    const computeB = () => {
        const vh = Math.floor(window.innerHeight);
        if (vh <= THRESHOLD_B) return null;
        const raw = BASE_B + (vh - THRESHOLD_B) * 0.1;
        const adjusted = raw - OFFSET_B;
        return Math.max(0, adjusted);
    };

    useEffect(() => {
        const isMobile = /Mobi|Android/i.test(navigator.userAgent);

        const updateBoth = () => {
            setDivHeightA(computeA());
            setDivHeightB(computeB());
        };

        updateBoth(); // run on mount

        if (!isMobile) {
            window.addEventListener("resize", updateBoth);
            return () => window.removeEventListener("resize", updateBoth);
        }
    }, []);

    const containerRef = useRef(null);
    const [fontSizeSettings, setFontSizeSettings] = useState({
        min: 14,
        max: 60,
        fixed: null,
    });

     useEffect(() => {
        const updateFontSettings = () => {
            const container = containerRef.current;
            if (!container) return;

            const { offsetWidth: width, offsetHeight: height } = container;

            if (width === 509 && height === 46) {
                setFontSizeSettings({ min: 20, max: 20, fixed: 20 }); // fixed size
            } else if (width < 550 || height < 47) {
                setFontSizeSettings({ min: 14, max: 40, fixed: null }); // smaller container
            } else {
                setFontSizeSettings({ min: 30, max: 80, fixed: null }); // larger container
            }
        };

        updateFontSettings();
        window.addEventListener("resize", updateFontSettings);

        return () => window.removeEventListener("resize", updateFontSettings);
    }, []);

    const containerRef3 = useRef(null);
    const [fontSizeSettings3, setFontSizeSettings3] = useState({
        min: 14,
        max: 60,
        fixed: null,
    });

    useEffect(() => {
        const updateFontSettings3 = () => {
            const container = containerRef3.current;
            if (!container) return;

            const { offsetWidth: width, offsetHeight: height } = container;

            if (width === 510 && height >= 380 && height <= 381) {
                setFontSizeSettings3({ min: 23, max: 23, fixed: 23 }); // fixed size
            } else if (width < 510 || height < 390) {
                setFontSizeSettings3({ min: 14, max: 40, fixed: null }); // smaller container
            } else {
                setFontSizeSettings3({ min: 20, max: 100, fixed: null }); // larger container
            }
        };

        updateFontSettings3();
        window.addEventListener("resize", updateFontSettings3);

        return () => window.removeEventListener("resize", updateFontSettings3);
    }, []);

    const containerRef4 = useRef(null);
    const [fontSizeSettings4, setFontSizeSettings4] = useState({
        min: 20,
        max: 60,
        fixed: null,
    });

    useEffect(() => {
        const updateFontSettings4 = () => {
            const container = containerRef4.current;
            if (!container) return;

            const { offsetWidth: width, offsetHeight: height } = container;

            if (width === 241 && height >= 23 && height <= 24) {
                setFontSizeSettings4({ min: 25, max: 25, fixed: 25 }); // fixed size
            } else if (width < 241 || height < 23) {
                setFontSizeSettings4({ min: 15, max: 25, fixed: null }); // smaller container
            } else {
                setFontSizeSettings4({ min: 14, max: 80, fixed: null }); // larger container
            }
        };

        updateFontSettings4();
        window.addEventListener("resize", updateFontSettings4);

        return () => window.removeEventListener("resize", updateFontSettings4);
    }, []);

    const containerRef2 = useRef(null);
    const [fontSizeSettings2, setFontSizeSettings2] = useState({
        min: 30,
        max: 120,
        fixed: null,
    });

    useEffect(() => {
        const updateFontSettings2 = () => {
            const container = containerRef2.current;
            if (!container) return;

            const { offsetWidth: width, offsetHeight: height } = container;

            if (width === 400 && height === 100) {
                setFontSizeSettings2({ min: 34, max: 34, fixed: 34 }); // fixed size
            } else if (width < 400 || height < 100) {
                setFontSizeSettings2({ min: 18, max: 100, fixed: null }); // smaller container
            } else {
                setFontSizeSettings2({ min: 35, max: 120, fixed: null }); // larger container
            }
        };

        updateFontSettings2();
        window.addEventListener("resize", updateFontSettings2);

        return () => window.removeEventListener("resize", updateFontSettings2);
    }, []);

    const [isMobile, setIsMobile] = useState(window.innerWidth < 970);

    useEffect(() => {
    const handleResize = () => {
        setIsMobile(window.innerWidth < 970);
    };

    // Set initial state and add resize listener
    window.addEventListener('resize', handleResize);

    // Cleanup on component unmount
    return () => {
        window.removeEventListener('resize', handleResize);
    };
    }, []);

    useEffect(() => {
    function updateExtension() {
    const navbar = document.querySelector('.navbarGreen');
    const image = document.querySelector('.background');
    const footer = document.querySelector('.footerDiv');
    const extension = document.querySelector('.extension');

    if (!navbar || !image || !footer || !extension) return;

    // ✅ Already correct top position — DO NOT change
    const extensionTop = navbar.offsetHeight + image.offsetHeight;

    // ✅ Measure where the footer actually starts
    const footerTop = footer.getBoundingClientRect().top + window.scrollY;

    // ✅ Set height based on actual gap
    const height = footerTop - extensionTop;

    extension.style.top = `${extensionTop}px`; // leave this alone
    extension.style.height = `${Math.max(height, 0)}px`;

    // 🔍 Debug output
    //console.log('Extension top (unchanged):', extensionTop);
    //console.log('Footer top (actual):', footerTop);
    //console.log('Final height (footerTop - extensionTop):', height);
    }

    updateExtension();
    window.addEventListener('resize', updateExtension);
    window.addEventListener('scroll', updateExtension);

    return () => {
    window.removeEventListener('resize', updateExtension);
    window.removeEventListener('scroll', updateExtension);
    };
    }, []);

   const linkToPage =() => {
        window.gtag('config', 'AW-17751635605');
        window.gtag('event', 'conversion',  {'send_to': 'AW-17751635605/yMDqCIv56sQbEJXt0ZBC'})

        const link = '/quiz';
        window.location.href = link;
    }

    return (
         <div className="main2">

            <img src={isMobile ? "images/backgroundCut2.png" : "images/background5.png"} className="background"></img>
            <div className="overlay"></div>
            <div className="extension"></div>
            <div className="displayMain">
            <div className="welcome"  ref={containerRef2} style={{
                  height: divHeightB != null ? `${divHeightB}px` : undefined,
                }}>
                    <AutoTextSize
                    mode="box"
                    minFontSizePx={fontSizeSettings2.fixed ?? fontSizeSettings2.min}
                    maxFontSizePx={fontSizeSettings2.fixed ?? fontSizeSettings2.max}
                    fontSizePrecisionPx={0.1}
                    style={{
                        fontFamily: "sans-serif",
                        color: "white",
                        textAlign: "center",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        transform: "translateY(5%)",
                    }}
                >
                     Welcome to Assa  
                </AutoTextSize>                                   
                    </div>
                <div className="textAbout"  style={{
                  height: divHeightA != null ? `${divHeightA}px` : undefined,
                }}>
              
                <div ref={containerRef3} style={{
                    height: "81%", width: "100%", display: "flex", justifyContent:"center", alignItems: "center"
                }}>
                <AutoTextSize
                    mode="box"
                    minFontSizePx={fontSizeSettings3.fixed ?? fontSizeSettings3.min}
                    maxFontSizePx={fontSizeSettings3.fixed ?? fontSizeSettings3.max}
                    fontSizePrecisionPx={0.1}
                    style={{
                        fontFamily: "sans-serif",
                        color: "white",
                        textAlign: "center",
                        width: "100%",
                        display: "flex",    // Optional: helps center text
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                Assa is an app for learning Chinese language with associations. Every Chinese character consists of small parts that are called radicals. 
                In our app we create our own associations for the characters to better memorize characters based on the radicals that they consist of. We hope this way will help you to remember characters in associations way but not as some random pictures which exist in infinite amount. So, you don't know how to remember characters? Then try out Assa <br />
                </AutoTextSize>
                </div>
                <div style={{
                    height: "9%", width: "100%", display: "flex", justifyContent:"center", alignItems: "center"
                }}>
                <div ref={containerRef4} onClick={linkToPage} style={{ cursor: 'pointer' }} className="tryOut">  
                    <AutoTextSize
                    mode="box"
                    minFontSizePx={fontSizeSettings4.fixed ?? fontSizeSettings4.min}
                    maxFontSizePx={fontSizeSettings4.fixed ?? fontSizeSettings4.max}
                    fontSizePrecisionPx={0.1}
                    style={{
                        color: "black",
                        textAlign: "center",
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >Try out now!</AutoTextSize>
                </div>
                </div>
                </div>
            </div>
        </div>
    )
}